<template>
  <div class="kt-portlet">
    <template v-if="isPreview">
      <h3 class="kt-portlet__head-title my-5 pl-2">Unit Assignments</h3>

      <v-card elevation="0" class="pl-2">
        <v-tabs>
          <v-tab href="#users"> Assigned Users</v-tab>
          <v-tab-item value="users">
            <v-card class="mx-auto" flat>
              <v-card-text>
                <v-chip-group
                  active-class="primary--text"
                  column
                  class="mx-auto"
                  v-if="assigned_users.length > 0"
                >
                  <v-chip
                    v-for="(userUnit, index) in assigned_users"
                    :key="index"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ userUnit.user.name }} ({{
                            userUnit.user.dealer.name
                          }})
                        </span>
                      </template>
                      <span>
                        Due Date: {{ userUnit.due_date | formatDate }}
                      </span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div v-else class="text-center">
                  {{ loadingShowUsers ? 'Loading Data' : 'No Users Assigned' }}
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab href="#playlist"> Assigned Playlists </v-tab>
          <v-tab-item value="playlist">
            <v-card class="mx-auto" flat>
              <v-card-text>
                <v-chip-group
                  v-if="assigned_playlists.length > 0"
                  active-class="primary--text"
                  column
                  class="mx-auto"
                >
                  <v-chip
                    v-for="(playlist, index) in assigned_playlists"
                    :key="index"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ playlist.playlist.name }} ({{
                            playlist.playlist.user.dealer.name
                          }})
                        </span>
                      </template>
                      <span>
                        Number of units:
                        <strong>{{ playlist.playlist.units.length }}</strong>
                      </span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div v-else class="text-center">
                  {{
                    loadingShowPlaylists
                      ? 'Loading Data'
                      : 'No Playlists Assigned'
                  }}
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </template>
    <template v-else>
      <div class="d-flex w-100">
        <v-tabs>
          <v-tab href="#users"> Assign to users </v-tab>
          <v-tab-item value="users">
            <AssignUnit
              :unit_id="unitId"
              v-model="showAssignUnit"
              :dealers="dealers"
              :isEdit="isEdit"
              v-on:users="getAssigned"
            />
            <div class="text-center mb-3">
              <v-btn
                :loading="loadingShowUsers"
                text
                small
                color="primary"
                @click="fetchAssignedUsers"
              >
                {{ !isShowAssignedUsers ? 'Show' : 'Hide' }} Assigned Users
              </v-btn>
            </div>
            <v-card
              :max-height="isEdit ? 450 : 750"
              class="mx-auto"
              v-if="isShowAssignedUsers"
              flat
            >
              <v-card-text>
                <v-chip-group
                  active-class="primary--text"
                  column
                  class="mx-auto"
                  v-if="assigned_users.length > 0"
                >
                  <v-chip
                    v-for="(userUnit, index) in assigned_users"
                    :key="index"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ userUnit.user.name }} ({{
                            userUnit.user.dealer.name
                          }})
                        </span>
                      </template>
                      <span>
                        Due Date: {{ userUnit.due_date | formatDate }}
                      </span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div v-else class="text-center">No Users Assigned</div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab href="#playlist"> Assign to Playlist </v-tab>
          <v-tab-item value="playlist">
            <assign-playlist :unit="unit" @playlist="getPlaylist" />
            <div class="text-center mb-3">
              <v-btn
                :loading="loadingShowPlaylists"
                text
                small
                color="primary"
                @click="fetchAssignedPlaylists"
              >
                {{ !isShowAssignedPlaylists ? 'Show' : 'Hide' }} Assigned
                Playlists
              </v-btn>
            </div>
            <v-card
              :max-height="isEdit ? 450 : 750"
              class="mx-auto"
              v-if="isShowAssignedPlaylists"
              flat
            >
              <v-card-text>
                <v-chip-group
                  v-if="assigned_playlists.length > 0"
                  active-class="primary--text"
                  column
                  class="mx-auto"
                >
                  <v-chip
                    v-for="(playlist, index) in assigned_playlists"
                    :key="index"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ playlist.playlist.name }} ({{
                            playlist.playlist.user.dealer.name
                          }})
                        </span>
                      </template>
                      <span>
                        Number of units:
                        <strong>{{ playlist.playlist.units.length }}</strong>
                      </span>
                    </v-tooltip>
                  </v-chip>
                </v-chip-group>
                <div v-else class="text-center">No Playlists Assigned</div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </template>
  </div>
</template>
<script>
import AssignUnit from '../../dialog-box/AssignUnit.vue';
import UnitPlaylist from '../../dialog-box/UnitPlaylist.vue';
import AssignPlaylist from '@/components/client-lms/UnitPage/partials/AssignPlaylist';
import dayjs from 'dayjs';

export default {
  name: 'Assignment',
  props: {
    unit: Object,
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AssignUnit,
    UnitPlaylist,
    AssignPlaylist,
  },
  data: () => ({
    isShowAssignedUsers: false,
    loadingShowUsers: false,
    assigned_users: [],
    isShowAssignedPlaylists: false,
    loadingShowPlaylists: false,
    assigned_playlists: [],
    isPreview: false,
    isEdit: false,
    showShareUnit: false,
    showAssignUnit: false,
    showUnitPlaylist: false,
    dealers: [],
    isFetching: false,
  }),

  filters: {
    formatDate(date) {
      let result = dayjs(date);

      return result.format('MMM DD, YYYY');
    },
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },

    unitId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.isPreview = this.currentRouteName == 'PreviewUnitPage' ? true : false;
    this.isEdit = this.currentRouteName == 'EditUnitPage' ? true : false;
    if (!this.isPreview || !this.isEdit) {
      this.fetchUnit();
    }
    if (this.isPreview) {
      this.fetchAssignedUsers();
      this.fetchAssignedPlaylists();
    }
  },
  methods: {
    getAssigned(item) {
      this.$emit('users', item);
    },
    getPlaylist(item) {
      this.$emit('playlist', item);
    },
    fetchUnit() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios
        .get('/client/lms/unit/' + this.unitId, {
          params: {
            type: 'module',
          },
        })
        .then(({ data }) => {
          this.unit = data.unit;
          this.isFetching = false;
          this.$parent.unitPageLoading = false;
          console.log(data.unit);
        });
    },
    fetchAssignedUsers() {
      if (this.isShowAssignedUsers) {
        this.isShowAssignedUsers = false;
        return;
      }
      this.loadingShowUsers = true;
      if (this.assigned_users.length > 0) {
        this.loadingShowUsers = false;
        this.isShowAssignedUsers = true;
        return;
      }
      this.axios
        .get(`/client/lms/show/unit/${this.unitId}/assigned/users`)
        .then(({ data }) => {
          this.assigned_users = data;
        })
        .catch((data) => {
          console.log('something went wrong in fetching assigned users');
        })
        .finally(() => {
          this.loadingShowUsers = false;
          this.isShowAssignedUsers = true;
        });
    },
    fetchAssignedPlaylists() {
      if (this.isShowAssignedPlaylists) {
        this.isShowAssignedPlaylists = false;
        return;
      }
      this.loadingShowPlaylists = true;
      if (this.assigned_playlists.length > 0) {
        this.loadingShowPlaylists = false;
        this.isShowAssignedPlaylists = true;
        return;
      }
      this.axios
        .get(`/client/lms/show/unit/${this.unitId}/assigned/playlists`)
        .then(({ data }) => {
          this.assigned_playlists = data;
        })
        .catch((data) => {
          console.log('something went wrong in fetching assigned users');
        })
        .finally(() => {
          this.loadingShowPlaylists = false;
          this.isShowAssignedPlaylists = true;
        });
    },
  },
};
</script>
